import * as z from "zod/v4";

export const getTags = {
  name: "getTags" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(z.string()),
};
